import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore } from "@angular/fire/firestore";
import { Observable, from, of } from "rxjs";
import { map, take, switchMap, tap } from "rxjs/operators";
import * as firebase from "firebase/app";
import "firebase/auth";
import { NavController } from "@ionic/angular";
import { CalendarService } from "./calendar.service";
import { User } from '../models/user.model';

declare const gapi;

export const COLLECTIONS = {
  users: "users",
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user: Observable<any>;

  constructor(
    private afAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private calendarService: CalendarService
  ) {
    this.user = this.afAuth.authState.pipe(
      switchMap((user) => {
        // console.log('auth changed: ', user);
        if (user) {
          return this.firestore
            .doc<firebase.User>(`users/${user.uid}`)
            .valueChanges()
            .pipe(take(1));
        } else {
          return of(null);
        }
      })
    );
    this.calendarService.initClient();
  }


  async signInWithGoogle(): Promise<User | null> {
    //ต้องการใช้งาน google api ซึ่งเป็นคนละส่วนกันกับ firebase ทำให้ต้อง loggin google ก่อน
    //get instance
    const authInstance = gapi.auth2.getAuthInstance();
    //log user in to google with gapi
    let googleUser = null;
    try {
      googleUser = await authInstance.signIn();
    } catch (e) {
      return null;
    }
    
    //when done received there 'json web token'
    if (googleUser.isSignedIn()) {
      // console.log('signed in');
      //get credential to log in to firebase with 'json web token'
      const apiToken = googleUser.getAuthResponse().id_token;
      const fbCredential = firebase.auth.GoogleAuthProvider.credential(
        apiToken
      );
        // this.afAuth.signInAndRetrieveDataWithCredential(fbCredential)
      const firebaseUser = await this.afAuth.signInWithCredential(fbCredential);
      const userDataExist = await this.checkUserDataInFirestore(firebaseUser, COLLECTIONS.users);
      if(userDataExist) {
        return this.getUserFromFirestore(firebaseUser, COLLECTIONS.users).toPromise();
      } else {
        const updateUserDataResult = this.updateUserDataToFirestore(firebaseUser, COLLECTIONS.users);
        if(updateUserDataResult) {
          return this.getUserFromFirestore(firebaseUser, COLLECTIONS.users).toPromise();
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }

  async signOut() {
    await this.afAuth.signOut();
    const auth = gapi.auth2.getAuthInstance();
    auth.signOut();
  }

  async checkUserDataInFirestore(credential: firebase.auth.UserCredential, collection: string): Promise<Boolean> {
    const uid: string = credential.user.uid;
    const hasUser = await this.firestore.doc<User>(`${collection}/${uid}`).get().toPromise();
    if(hasUser.exists) {
      return true;
    } else {
      return false;
    }
  }

  getUserFromFirestore(credential: firebase.auth.UserCredential, collection: string): Observable<User> {
    const uid: string = credential.user.uid;
    return this.firestore.doc<User>(`${collection}/${uid}`).valueChanges().pipe(take(1));
  }

  async updateUserDataToFirestore(credential: firebase.auth.UserCredential, collection: string): Promise<Boolean> {
    const uid: string = credential.user.uid;
    const userConfig: User = {
      displayName: credential.user.displayName,
      email: credential.user.email,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      permissions: [],
      role: "OWNER",
    }
    try {
      await this.firestore.doc<User>(`${collection}/${uid}`).set(userConfig);
      return true;
    } catch (e) {
      return false;
    }
  }
}
